module.exports = __webpack_public_path__ + "img/file-lines-solid.b530e506.svg";